<template>
  <div class="payment-denied">
    <div
      class="payment-denied__content"
      :class="{ 'payment-denied__content--visible': isIconResultVisible }"
    >
      <VIconResultMessage
        :type="iconResultMessageData.type"
        :message="iconResultMessageData.message"
        :iconSvgName="iconResultMessageData.iconSvgName"
      />

      <div class="payment-denied__actions">
        <VButton
          slot="buttons"
          id="modal__form-btn-field-readonly"
          text="Alterar dados do cartão"
          width="100%"
          @click.native="changeCreditCardData"
        />

        <VButton
          slot="buttons"
          id="modal__form-btn-field-readonly2"
          text="Pagar no guichê"
          variant="secondary"
          width="100%"
          @click.native="openServiceDeskDrawer"
        />
      </div>
    </div>
    <DrawerBottomPayment
      :openDrawer="openDrawer"
      @credit-payment="
        () => {
          $router.push({ name: 'credit-card-payment', params: { amount: $route.params.amount } });
        }
      "
      @toggle-drawer="(open) => (openDrawer = open)"
      @payment-without-card="
        () => {
          mostCommonPagesAnalytics({
            eventType: 'submit',
            step: 'seleção_cartão_ou_particular',
            screen: 'pagamento_recusado_cartão',
            complementaryObject: {
              payment: {
                type: 'particular',
              },
            },
          });
        }
      "
    />
  </div>
</template>

<script>
import VButton from '@/components/commons/VButton.vue';
import VIconResultMessage from '@/components/commons/VIconResultMessage';
import DrawerBottomPayment from './partials/DrawerBottomPayment.partial.vue';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'PaymentDenied',
  mixins: [dataLayersMixin],
  components: {
    VButton,
    VIconResultMessage,
    DrawerBottomPayment,
  },
  data: () => ({
    openDrawer: false,
    iconResultMessageData: {
      type: 'error',
      message: ['Não foi possível', 'efetuar o pagamento.'],
      iconSvgName: 'creditCard',
    },
    isIconResultVisible: false,
  }),

  mounted() {
    this.mostCommonPagesAnalytics({
      step: 'seleção_cartão_ou_particular',
      screen: 'pagamento_recusado_cartão',
      complementaryObject: {
        payment: {
          type: 'particular_com_cartão',
          installments: this.$route.params.installments,
          status: 'falha',
        },
      },
    });
    this.showIconResult();
  },

  methods: {
    openServiceDeskDrawer() {
      this.openDrawer = true;
    },
    changeCreditCardData() {
      this.mostCommonPagesAnalytics({
        eventType: 'submit',
        step: 'seleção_cartão_ou_particular',
        screen: 'pagamento_recusado_cartão',
        complementaryObject: {
          payment: {
            type: 'alterar_dados_cartão',
          },
        },
      });
      this.$router.push({
        name: 'credit-card-payment',
        params: { amount: this.$route.params.amount },
      });
    },
    previousRoute() {
      this.$router.go(-1);
    },

    showIconResult() {
      this.isIconResultVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-denied {
  height: 100%;
  width: 100%;

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100vh - 100px);
    position: relative;
    width: 100%;
    margin-bottom: 20px;

    &--visible {
      opacity: 1;
    }

    .v-icon-result-message {
      transform: translateY(-50%);
    }
  }

  &__actions {
    align-items: center;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 8px;
    position: absolute;
    width: 100%;

    & button:first-child {
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.payment-denied {
  overflow: hidden;
  height: 100%;

  > .container {
    background-color: white;
  }
}
</style>
